module.exports = __webpack_public_path__ + "static/media/mobile-shop.b4f728f5.png";